import { Switch } from "@headlessui/react";

const Toogle = ({ isToogleOn, setisToogleOn }) => {
  return (
    <div className="py-16">
      <Switch
        checked={isToogleOn}
        onChange={setisToogleOn}
        className={`${isToogleOn ? "bg-secondary" : "bg-wite"}
          border-transparent relative inline-flex h-[22px] w-[45px] shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${isToogleOn ? "translate-x-[23px]" : "translate-x-0"}
            pointer-events-none inline-block h-[18px] w-[18px] transform rounded-full bg-primary shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
};

export default Toogle;
